import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const BarcodeScanner = () => {
  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Escáner de Código de Barras" /> */}
      <BreadcrumbTwo />


      <div className="rounded border border-gray-200 bg-white p-6 shadow dark:border-gray-700 dark:bg-boxdark">
        {/* Aquí irá la configuración del escáner de código de barras */}
        <p className="text-gray-600 dark:text-gray-300">Configuración del escáner próximamente...</p>
      </div>
    </DefaultLayout>
  );
};

export default BarcodeScanner;
